module.exports = __webpack_public_path__ + "img/pk.ba6eda8e.jpg";